import { render, staticRenderFns } from "./ErrorSession.vue?vue&type=template&id=55b8cb80&scoped=true"
import script from "./ErrorSession.vue?vue&type=script&lang=js"
export * from "./ErrorSession.vue?vue&type=script&lang=js"
import style0 from "./ErrorSession.vue?vue&type=style&index=0&id=55b8cb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8cb80",
  null
  
)

export default component.exports